'use client';

import React, { useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

interface ToastNotificationProps {
  message: string;
  type: 'success' | 'error' | 'info' | 'warning';
  isVisible: boolean;
  onClose: () => void;
  duration?: number;
}

const ToastNotification = ({
  message,
  type,
  isVisible,
  onClose,
  duration = 4000
}: ToastNotificationProps) => {
  useEffect(() => {
    if (isVisible && duration > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [isVisible, duration, onClose]);

  const getToastConfig = (type: string) => {
    switch (type) {
      case 'success':
        return {
          icon: 'CheckCircleIcon',
          bgColor: 'bg-success',
          textColor: 'text-success-foreground',
          borderColor: 'border-success'
        };
      case 'error':
        return {
          icon: 'ExclamationTriangleIcon',
          bgColor: 'bg-error',
          textColor: 'text-error-foreground',
          borderColor: 'border-error'
        };
      case 'warning':
        return {
          icon: 'ExclamationTriangleIcon',
          bgColor: 'bg-warning',
          textColor: 'text-warning-foreground',
          borderColor: 'border-warning'
        };
      case 'info':
      default:
        return {
          icon: 'InformationCircleIcon',
          bgColor: 'bg-primary',
          textColor: 'text-primary-foreground',
          borderColor: 'border-primary'
        };
    }
  };

  if (!isVisible) return null;

  const config = getToastConfig(type);

  return (
    <div data-component-id="src/app/home-dashboard/components/ToastNotification.tsx:70:4" data-component-path="src/app/home-dashboard/components/ToastNotification.tsx" data-component-line="70" data-component-end-line="86" data-component-file="ToastNotification.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22fixed%20top-4%20right-4%20z-%5B200%5D%20animate-in%20slide-in-from-top-2%20duration-300%22%7D" className="fixed top-4 right-4 z-[200] animate-in slide-in-from-top-2 duration-300">
      <div data-component-id="src/app/home-dashboard/components/ToastNotification.tsx:71:6" data-component-path="src/app/home-dashboard/components/ToastNotification.tsx" data-component-line="71" data-component-end-line="85" data-component-file="ToastNotification.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" className={`
        flex items-center gap-3 px-4 py-3 rounded-lg shadow-floating border
        ${config.bgColor} ${config.textColor} ${config.borderColor}
        max-w-sm min-w-80
      `}>
        <Icon data-component-id="src/app/home-dashboard/components/ToastNotification.tsx:76:8" data-component-path="src/app/home-dashboard/components/ToastNotification.tsx" data-component-line="76" data-component-end-line="76" data-component-file="ToastNotification.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22className%22%3A%22flex-shrink-0%22%7D" name={config.icon as any} size={20} className="flex-shrink-0" />
        <p data-component-id="src/app/home-dashboard/components/ToastNotification.tsx:77:8" data-component-path="src/app/home-dashboard/components/ToastNotification.tsx" data-component-line="77" data-component-end-line="77" data-component-file="ToastNotification.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-sm%20font-medium%20flex-1%22%7D" className="text-sm font-medium flex-1">{message}</p>
        <button data-component-id="src/app/home-dashboard/components/ToastNotification.tsx:78:8" data-component-path="src/app/home-dashboard/components/ToastNotification.tsx" data-component-line="78" data-component-end-line="84" data-component-file="ToastNotification.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22flex-shrink-0%20hover%3Aopacity-80%20transition-smooth%22%7D"
          onClick={onClose}
          className="flex-shrink-0 hover:opacity-80 transition-smooth"
          aria-label="Close notification"
        >
          <Icon data-component-id="src/app/home-dashboard/components/ToastNotification.tsx:83:10" data-component-path="src/app/home-dashboard/components/ToastNotification.tsx" data-component-line="83" data-component-end-line="83" data-component-file="ToastNotification.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22XMarkIcon%22%7D" name="XMarkIcon" size={16} />
        </button>
      </div>
    </div>
  );
};

export default ToastNotification;